import { ColumnsProps } from 'components/Table/Table'
import i18n from 'i18n'

export const columnTrackable = (): ColumnsProps[] => [
  {
    align: 'right',
    fixed: true,
    name: 'percentStatus',
    title: i18n.t('common:traceability'),
    translate: true
  }
]

export const distColumns = (): ColumnsProps[] => [
  {
    align: 'right',
    fixed: true,
    name: 'invoice',
    title: i18n.t('tables:invoice'), // Nota fiscal
    view: ['admin', 'viewer']
  },
  {
    align: 'right',
    fixed: true,
    name: 'invoicedate',
    title: i18n.t('tables:invoiceDate'), // Data emissão nota fiscal
    view: ['admin', 'viewer']
  },
  {
    align: 'right',
    name: 'order',
    title: i18n.t('tables:order'), // Pedido cliente
    view: ['admin', 'viewer']
  },
  {
    align: 'right',
    fixed: true,
    name: 'orderdate',
    title: i18n.t('tables:orderDate'), // Data pedido
    view: ['admin']
  },
  {
    align: 'right',
    name: 'cargo',
    title: i18n.t('tables:charge'), // Carga
    view: ['admin', 'viewer']
  },
  {
    align: 'right',
    name: 'shipmentdate',
    title: i18n.t('tables:loadingDate'), // Data carregamento
    view: ['admin']
  },
  {
    align: 'right',
    name: 'destinationcnpj',
    title: i18n.t('common:destinationId'), // ID Cliente (Destino)
    view: ['admin', 'viewer']
  },
  {
    name: 'destinationname',
    title: i18n.t('tables:corporatePurposeDestiny'), // Razão social cliente (Destino)
    view: ['admin', 'viewer']
  },
  {
    name: 'destinationCountry',
    title: i18n.t('tables:destinationCountry'), // País cliente (destino)
    view: ['admin', 'viewer']
  },
  {
    name: 'destinationstate',
    title: i18n.t('tables:stateOfDestionation'), // Estado cliente (destino)
    view: ['admin', 'viewer']
  },
  {
    name: 'destinationcity',
    title: i18n.t('tables:destinationCity'), // Cidade cliente (destino)
    view: ['admin', 'viewer']
  },
  {
    align: 'right',
    name: 'qtt',
    title: i18n.t('tables:totalOrderQty'), // Qtde itens
    view: ['admin', 'viewer']
  },
  {
    align: 'right',
    name: 'unitMeasureInvoice',
    title: i18n.t('tables:unitMeasure'), // Unidade medida
    view: ['admin', 'viewer']
  },
  {
    align: 'right',
    name: 'stockcnpj',
    title: i18n.t('tables:issuerId'), // ID emissor nota fiscal
    view: ['admin']
  },
  {
    name: 'docnamelocalstock',
    title: i18n.t('tables:issuerName'), // Razão social emissor nota fiscal
    view: ['admin']
  },
  {
    name: 'issuerCountry',
    title: i18n.t('tables:issuerCountry'), // País emissor nota fiscal
    view: ['admin']
  },
  {
    name: 'issuerState',
    title: i18n.t('tables:issuerState'), // Estado emissor nota fiscal
    view: ['admin']
  },
  {
    name: 'issuerCity',
    title: i18n.t('tables:issuerCity'), // Cidade emissor nota fiscal
    view: ['admin']
  }
]

export const allColumns = (): ColumnsProps[] => [
  {
    align: 'right',
    fixed: true,
    name: 'invoice',
    title: i18n.t('tables:invoice')
  },
  {
    align: 'right',
    fixed: true,
    name: 'invoicedate',
    title: i18n.t('tables:invoiceDate')
  },
  {
    align: 'right',
    fixed: true,
    name: 'mainOrderNumber',
    title: i18n.t('tables:mainOrderNumber')
  },
  {
    align: 'right',
    name: 'order',
    title: i18n.t('tables:order')
  },
  {
    align: 'right',
    name: 'cargo',
    title: i18n.t('tables:charge')
  },
  {
    align: 'right',
    name: 'orderdate',
    title: i18n.t('tables:orderDate')
  },
  {
    align: 'right',
    name: 'clientOrderNumber',
    title: i18n.t('tables:clientOrderNumber')
  },
  {
    align: 'right',
    name: 'stockcnpj',
    title: i18n.t('tables:shipperCNPJ')
  },
  {
    align: 'right',
    name: 'docnamelocalstock',
    title: i18n.t('tables:shipperCorporateName')
  },
  {
    align: 'right',
    name: 'shipmentdate',
    title: i18n.t('tables:loadingDate')
  },
  {
    align: 'right',
    name: 'containerNumber',
    title: i18n.t('tables:containerNumber')
  },
  {
    align: 'right',
    name: 'qtt',
    title: i18n.t('tables:totalOrderQty')
  },
  {
    name: 'invoicetype',
    title: i18n.t('tables:nfNature')
  },
  {
    align: 'right',
    name: 'destinationcnpj',
    title: i18n.t('common:destinationId')
  },
  {
    name: 'destinationname',
    title: i18n.t('tables:corporatePurposeDestiny')
  },
  {
    name: 'destinationcity',
    title: i18n.t('tables:destinationCity')
  },
  {
    name: 'destinationstate',
    title: i18n.t('tables:stateOfDestionation')
  },
  {
    name: 'destinationCountry',
    title: i18n.t('tables:destinationCountry')
  },
  {
    align: 'right',
    name: 'shippingcnpj',
    title: i18n.t('tables:carrierCNPJ')
  },
  {
    name: 'shippingcompany',
    title: i18n.t('tables:carrierCorporateName')
  },
  {
    name: 'truckplate',
    title: i18n.t('tables:vehiclePlate')
  },
  {
    name: 'driver',
    title: i18n.t('common:driver')
  }
]
